import fetch from 'utils/fetch';
import { Params, Notification, Result } from 'types';
import { Language, SortOrder } from 'enums';

function readingNotificationFactory(isUnread: boolean) {
  return async function endpoint(id: string) {
    try {
      const response = await fetch(
        `/api/notification/${id}/${isUnread ? 'un' : ''}read`,
        {
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          method: 'POST',
        }
      );

      return response.ok;
    } catch (err) {
      console.log(err);
      return false;
    }
  };
}
export const readNotification = readingNotificationFactory(false);
export const unreadNotification = readingNotificationFactory(true);

export async function getNotificationsCount() {
  try {
    const response = await fetch('/api/notification/received/count', {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      method: 'GET',
    });

    const rawNumber = await response.text();
    return Number(rawNumber);
  } catch (err) {
    console.log(err);
    return 0;
  }
}

export async function getNotifications(
  language: Language,
  filters: Params['filters'],
  size: number = 100,
  searchAfter?: string
) {
  const params: Params = {
    filters,
    searchAfter,
    sort: [
      {
        field: 'created',
        order: SortOrder.DESC,
      },
    ],
    size,
  };
  try {
    const response = await fetch(
      `/api/notification/received?language=${language}`,
      {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(params),
      }
    );

    const result: Result<Notification> = await response.json();
    return result;
  } catch (err) {
    console.log(err);
    return { items: [], count: 0, searchAfter: '' };
  }
}
